
 import React from 'react';
 const EmployeeCard = ({
  name,
  nationality ,
  qualification ,
  collegeDept ,
  empNumber ,
  hireDate ,
  idNumber,
  position,
 }) => {
   return (
     <div style={styles.card} className="employee-card" >
       <div style={styles.leftSection}>
         <h6 style={styles.name}>{name}</h6>
         <p style={styles.position}>{position} {collegeDept}</p>
         <div style={styles.chipContainer}>
           <div style={styles.chip}>
           <p style={styles.empNumber} className="pcard-empNumber">{empNumber}#</p>
           </div>
         </div>
       </div>
       <div style={styles.rightSection}>
<InfoRow label="القسم" value={collegeDept} />
<InfoRow label="آخر مؤهل" value={qualification} />
<InfoRow label="الجنسية" value={nationality} />
<InfoRow label="الهوية" value={idNumber} />
<InfoRow label="تاريخ التعيين" value={hireDate} />
       </div>
     </div>
   );
 };
 
 const InfoRow = ({ label, value }) => (
   <div style={styles.infoRow}>
     <span style={styles.label}>{label}:</span>
     <span style={styles.value}>{value}</span>
   </div>
 );
 
 const styles = {
   card: {
     display: 'flex',
     justifyContent: 'space-between',
     alignItems: 'center',
     width: '600px',
     height: '200px',
     backgroundColor: '#aa9a73',
     borderRadius: '16px',
     padding: '20px',
     color: '#fff',
     overflow: 'hidden',
   },
   leftSection: {
     flex: 1,
     display: 'flex',
     flexDirection: 'column',
     justifyContent: 'space-between',
   },
   name: {
    color:'#212529',
     fontSize: '1.3rem',
     fontWeight:'bold',
     margin: 0,
   },
   position: {
     fontSize: '1rem',
     fontStyle: 'italic',
     color:'#212529',
     fontWeight:'bold',
     marginBottom: '16px',
   },
   chipContainer: {
     display: 'flex',
     alignItems: 'center',
     gap: '8px',
   },
   chip: {
    
     backgroundColor: '#9e4f06',
     borderRadius: '4px',
     boxShadow: '0 2px 8px rgba(0, 0, 0, 0.2)',
   },
   empNumber: {
    color:'#ffff',
     fontSize: '1rem',
     fontWeight: 'bold',
     margin:'0px',
     padding:'3px'
   },
   rightSection: {
     flex: 1,
     backgroundColor: '#fff',
     color: '#333',
     borderRadius: '12px',
     padding: '16px',
     boxShadow: 'inset 0 2px 8px rgba(0, 0, 0, 0.2)',
   },
   infoRow: {
     display: 'flex',
     justifyContent: 'space-between',
     marginBottom: '8px',
     fontSize: '0.9rem',
   },
   label: {
     fontWeight: 'bold',
   },
   value: {
     color: '#9e4f06',
   },
 };
 
 export default EmployeeCard;
 